import React, { ReactNode, useState, useEffect } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';

export enum ButtonType {
  Ok = "Ok",
  YesNo = "YesNo"
}

interface Props {
  open: any;
  title?: string;
  buttonType?: ButtonType;
  onClose?: () => void;
  onClickOk?: () => void;
  onClickYes?: () => void;
  onClickNo?: () => void;
  children?: ReactNode;
}

export default function DefaultDialog({
  open,
  title = '確認',
  buttonType = ButtonType.Ok,
  onClose = () => {},
  onClickOk = () => {},
  onClickYes = () => {},
  onClickNo,
  children
}: Props) {
  const [ dialogOpen, setDialogOpen ] = useState(false);

  useEffect(() => {
    setDialogOpen(open ? true : false);
  }, [open]);

  return (
    <Dialog
      open={dialogOpen}
      onClose={onClose}
    >
      <DialogTitle>
        {title}
      </DialogTitle>
      <DialogContent>
        <Box sx={{'whiteSpace': 'pre-wrap'}}>{children}</Box>
      </DialogContent>
      <DialogActions>
        {buttonType == ButtonType.Ok &&
          <Button color="primary" variant="contained" onClick={onClickOk}>OK</Button>
        }
        {buttonType == ButtonType.YesNo &&
          <>
          <Button color="primary" variant="outlined" onClick={onClickNo || onClose}>いいえ</Button>
          <Button color="error" variant="contained" onClick={onClickYes}>はい</Button>
          </>
        }
      </DialogActions>
    </Dialog>
  );
}

